import axiosInstance from "../../../interceptor/intercetptor-inctence";

export const paymentIn = (formData) => {
    return axiosInstance.post(`/api/test-payment/credit-wallet-amount`, formData);
}

export const paymentOut = (formData) => {
    return axiosInstance.post(`/api/test-payment/debit-wallet-amount`, formData);
}

export const getPayinPayOutList = (formData) => {
    return axiosInstance.post(`/api/lab-transaction/payin-payout-list`, formData);
}